import React from "react";
import { publishToOrderModal } from "../../util/call-order-modal";
import { ArticleImageProps } from "../../types/article-image";
import { SalesArticleType } from "../../types/articles";
import "./article-image.scss";

const ArticleImage = (props: ArticleImageProps) => {
  const salesInfo = props.article.salesInformation;
  const hasPriceDeduction =
    props.article.priceInformation.discountPrice?.priceDeduction !== undefined;
  const priceDeduction = props.article.priceInformation.discountPrice?.priceDeduction;

  const handleClick = () =>
    publishToOrderModal(
      props.article,
      props.itemOrigin,
      props.productRecoModel,
      props.pageLocation
    );

  return (
    <div
      className="article-image eyeAbleContrastSkip"
      data-semantic-id="product-recommendation-tile"
      data-product-recommendation-tile-index={props.article.slot}
      data-product-recommendation-fragment={props.dataFragmentName}
      data-product-recommendation-model={props.productRecoModel}
      onClick={handleClick}
    >
      <img
        src={props.article.mainArticleImage}
        alt={`${props.l10n.imageMainView}, ${props.article.salesDesignation}`}
      />

      <div className="sales-tag-container">
        {salesInfo.isNew && (
          <div className="sales-tag">
            <span className="sales-label new-label">{props.l10n.newLabel}</span>
          </div>
        )}

        {salesInfo.hasRecommendedRetailPrice && hasPriceDeduction && (
          <div className="sales-tag">
            <span className="sales-label rrp-sale-label">
              {props.l10n.rrp} {priceDeduction}%
            </span>
          </div>
        )}

        {salesInfo.salesArticleType === SalesArticleType.ArticleSet &&
          hasPriceDeduction &&
          !salesInfo.flagAdvertisedAsCostFreeInSet && (
            <div className="sales-tag">
              <span className="sales-label set-sale-label">
                {props.l10n.setPrice} {priceDeduction}%
              </span>
            </div>
          )}

        {salesInfo.flagAdvertisedAsCostFreeInSet && (
          <div className="sales-tag">
            <span className="sales-label free-item-in-set-label">{props.l10n.saleLabel}</span>
          </div>
        )}

        {salesInfo.isSale &&
          salesInfo.salesArticleType === SalesArticleType.NormalArticle &&
          hasPriceDeduction && (
            <div className="sales-tag">
              <span className="sales-label article-sale-label">
                {props.l10n.saleLabel} {priceDeduction}%
              </span>
            </div>
          )}
      </div>
    </div>
  );
};

export default ArticleImage;
